import FinalizeService from "../../FinalizeServiceVotersByERO/FinalizeService";


function EroDashboard() {
 
  return (
    <>
     <FinalizeService />
    </>
  );
}

export default EroDashboard;
